/**
 * RTWO Event Bus — Null Engine Source Adapter
 */

import type { EventId, RTWOEventType, TopicId } from '../domain-models';
import type {
  EnginePublishResult,
  EnginePublisherResult,
  EngineSourceAdapterStatus,
  EngineSubscriberResult,
  IEngineSourceAdapter,
} from './engine-source-adapter-interface';

export class NullEngineSourceAdapter implements IEngineSourceAdapter {
  readonly adapterId = 'null-engine-source-adapter';
  readonly adapterName = 'Null Engine Source Adapter';

  async connect(): Promise<void> {}

  async disconnect(): Promise<void> {}

  getStatus(): EngineSourceAdapterStatus {
    return 'not_configured';
  }

  isReady(): boolean {
    return false;
  }

  async publishEvent(
    _eventType: RTWOEventType,
    _sourceModule: string,
    _targetModule: string | null,
    _payloadReference: string | null
  ): Promise<EnginePublishResult | null> {
    return null;
  }

  async registerPublisher(
    _moduleId: string,
    _supportedEvents: RTWOEventType[]
  ): Promise<EnginePublisherResult | null> {
    return null;
  }

  async registerSubscriber(
    _moduleId: string,
    _subscribedTopics: TopicId[]
  ): Promise<EngineSubscriberResult | null> {
    return null;
  }

  async routeEvent(_eventId: EventId): Promise<boolean> {
    return false;
  }

  async deliverEvent(_eventId: EventId, _subscriberId: string): Promise<boolean> {
    return false;
  }
}
